import { Modal } from "reactstrap";
import { useState } from "react";
import { X } from "react-feather";
import { modalEditIcon } from "../../../Shared/SVGs/Shared";
import { useSelector } from "react-redux";

const Step4EditModal = ({ style }) => {
  const [open, setOpen] = useState(true);
  const toggle = () => {
    setOpen(false);
  };
  const showCampaignStep = useSelector(
    (state) => state.videoPageStates.campaignsState.showCampaignStep
  );
  return (
    <Modal
      backdropClassName="back-drop"
      isOpen={open}
      toggle={toggle}
      contentClassName="custom-modals-edit"
      style={{
        top: showCampaignStep ? "276px" : "70px",
        left: showCampaignStep ? "0px" : "40px",
      }}
    >
      <div className="custom-modal-arrow"></div>
      <div className="cross">
        <div onClick={toggle}>
          <X size={30} color="black" />
        </div>
      </div>
      <div className="d-flex justify-content-center mb-2">{modalEditIcon}</div>
      <div className="d-flex justify-content-center">
        <p className="step">
          Ready to personalize your campaign? Click here to adjust the colors
          and make it your own
        </p>
      </div>
      <div className="d-flex justify-content-center">
        <div className="modal-text">
          Before sharing your campaign, take a moment to review, change the
          colors and fine-tune the campaign here. This is your chance to ensure
          everything looks just right before it goes live.
        </div>
      </div>
    </Modal>
  );
};

export default Step4EditModal;
